import { render, staticRenderFns } from "./UserInvitationConfirm.vue?vue&type=template&id=381fbe61&scoped=true&"
import script from "./UserInvitationConfirm.vue?vue&type=script&lang=js&"
export * from "./UserInvitationConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381fbe61",
  null
  
)

export default component.exports